<template>
  <div
    class="bt bg-F5F5F5 relative"
    :class="showTermDialog ? 'hidden' : 'scroll'"
    @touchend="showMoreTips = false"
  >
    <common-bar
      v-if="showTermTip"
      :class="{ 'mt-12': !topPromptStatus.showPrompt }"
      >本学期已结束，请到「学期时间」中维护下学期的起止日期</common-bar
    >
    <div
      v-show="showProtocol"
      class="fb fb-start-center c-006AFE pr-14 pl-14 font-28 h-48 bd-radio-8 m-0-16 mt-12 bg-006AFE-12"
    >
      <i class="iconfont font-46 mr-10">&#xe680;</i>
      <div>
        <div>
          <md-button class="notice-btn" type="text" @click="handlerToProtocol"
            >授权协议，点击授权<i class="iconfont">&#xe6c3;</i></md-button
          >
        </div>
      </div>
    </div>
    <div class="moreTip font-26" id="moreTip" v-if="showMoreTips">
      <div class="triangle"></div>
      <p class="moreTipContent">更多处设置“学年学期”</p>
    </div>
    <div class="header">
      <!-- 头部提示文字 -->
      <div class="h-56 fb-between-center p-0-15 font-32 relative">
        <div class="change-role c-006AFE" @click="handlerToChangeRole">
          <span class="mr-8">{{ computedHeaderInfo }}</span>
          <i class="iconfont font-28 c-006AFE" v-if="isCanChangeRole"
            >&#xe613;</i
          >
        </div>
        <div
          class="customer-service"
          v-if="computedShowCustomerService"
          @click="openCsLink"
        >
          <span class="iconfont mr-4 text-bold-600">&#xe731;</span>
          <span>客服</span>
        </div>

        <md-tip v-model="visible" type="primary" direction="top" class="cs-tip">
          点击这里咨询客服
        </md-tip>
      </div>

      <md-swiper
        v-if="bannerList && bannerList.length && !isZjCube && !isHeEducation"
        :show-indicators="bannerList.length > 1"
        ref="mySwipe"
        class="mb-15"
        :options="swiperOptions"
      >
        <md-swiper-item
          v-for="(item, index) in bannerList"
          :key="index"
          class="bd-radio-6 hidden"
        >
          <div class="p-0-15">
            <img
              @click="handlerGoBanner(item)"
              :src="item.imgUrl"
              class="bd-radio-6"
            />
          </div>
        </md-swiper-item>
      </md-swiper>
      <!-- 人脸录入 -->
      <div
        @click="entryInformation"
        v-if="
          isZjCube && (moduleIdList || []).indexOf('5') > -1 && !mixCloudOrg
        "
        class="h-56 bg-FFFFFF fb fb-cross-center fb-main-between m-0-15 bd-radio-6 p-0-15 mb-15"
      >
        <div class="fb fb-cross-center">
          <i class="iconfont font-40 c-171A1D mr-17">&#xe67b;</i>
          <span class="font-30 c-171A1D">信息录入</span>
        </div>
        <i class="iconfont font-32 c-171A1D-24">&#xe66b;</i>
      </div>
    </div>
    <div class="content">
      <div
        v-for="(card, index) in computedMenuCards"
        :key="index"
        class="m-0-15 bg-FFFFFF mb-15 bd-radio-6 hidden"
      >
        <div v-show="card.showTitle" class="c-171A1D-40 font-28 p-10-0 pl-17">{{
          card.title
        }}</div>
        <div class="fb fb-wrap">
          <div
            class="w-p-33 bd-box"
            v-for="(app, index) in card.menus"
            :class="{
              br: (index + 1) % 3 !== 0,
              bb: index < Math.floor((card.menus.length - 0.1) / 3) * 3,
              bt: index < 3 && card.showTitle
            }"
            tag="div"
            :key="app.id"
            @click="handlerHighlightModule(app, card)"
          >
            <div
              class="fb fb-col fb-cross-center fb-main-center h-105 ff-regular relative"
            >
              <i
                class="iconfont font-14 absolute c-FB602D icon-message"
                v-show="messageIdList.indexOf(+app.id) > -1"
                >&#xe64b;</i
              >
              <i class="iconfont c-171A1D font-48 mb-12" v-html="app.icon"></i>
              <span class="font-28"> {{ app.name }} </span>
              <span
                v-if="isShowFree(app).show"
                class="free-num inline-block bd-radio-20 font-20 c-fff bg-FF9200 p-0-6"
              >
                {{ isShowFree(app).hint }}
                <del class="opacity-60 ml-2" v-if="isShowFree(app).price"
                  >&yen;{{ isShowFree(app).price }}</del
                ></span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fb fb-cross-center fb-main-center mark" v-if="copyConfirm">
      <div class="bd-radio-6 bg-FFFFFF text-center w-280 h-125">
        <div class="bb p-15-0 p-0-32">
          <p class="font-30 lh-22 c-171A1D-56">您有任何意见建议，可邮箱至</p>
          <p class="font-30 lh-22 c-171A1D-56">chanpin@moredian.com</p>
        </div>
        <div class="fb fb-cross-center fb-main-between c-006AFE">
          <span class="font-34 item-flex-1 lh-48" @click="copyConfirm = false"
            >取消</span
          >
          <span
            class="font-34 text-bold item-flex-1 lh-48 bl"
            v-clipboard:copy="copyEmail"
            @click="handleCopySuccess"
            >复制邮箱</span
          >
        </div>
      </div>
    </div>
    <common-term-setting v-show="showTermDialog"></common-term-setting>
  </div>
</template>

<script>
import home from '@/mixin/home'
import manageRole from '@/mixin/manageRole'
import API from '@/api'
import { mapState, mapMutations } from 'vuex'
import { commonTermSetting, commonBar } from '@/components'
import { mcOpenLink, mcToast } from '@/utils/mcSdkUtils'
import { LEAVE_ROLE, TAB_ROLE_ID, PAGE_IN_MODULE } from '@/utils/constUtils'
import {
  timeFormat,
  getItem,
  setItem,
  removeItem,
  getLocalItem,
  enterFace,
  isHeEducationPlatform
} from '@/utils/comUtils'

// import { downloadFile } from '@/utils/dingSdkUtils'

const TERM_DIALOG_OPENED = 'TERM_DIALOG_OPENED' // 学年学期是否已打开

export default {
  mixins: [home, manageRole],
  components: {
    commonTermSetting,
    commonBar
  },
  props: {},
  data() {
    return {
      faceSourceType: 0, // 1:ding人脸库，2：魔方人脸库 3: 拱墅人脸库
      showTipClose: false, // 是否展示提示条的关闭
      listModuleShowStatus: true, // 免费套餐是否弹框 默认已弹 防止客服弹框闪烁问题
      showMoreTips: false,
      picker: null,
      mixCloudOrg: this.$store.getters.mixCloudOrg,
      menuList: {
        buttonName: [],
        routes: [],
        linkType: []
      },
      showProtocol: false, // 是否展示授权协议
      protocolData: [],
      isHeEducation: isHeEducationPlatform(),
      freeModules: [] // 免费试用模块
    }
  },
  computed: {
    // 套餐到期
    ...mapState('expireSku', [
      'topPromptStatus',
      'promptTitle',
      'promptContent',
      'alreadyExpirePrompt',
      'toBeExpirePrompt',
      'deviceToBeExpirePrompt',
      'deviceAlreadyExpirePrompt',
      'familyCallDeviceAlreadyExpire'
    ]),

    showTermTip() {
      const list = this.$store.getters.semesterList
      let currentDate = timeFormat(new Date(), 'YYYYMMDD')
      if (!this.curIsAdmin) {
        return false
      }
      // 只有一个学期、学期结束或者第二学期结束
      if (
        (list.length === 1 && list[0].schoolTermEndDimDay < currentDate) ||
        (list.length === 2 && list[1].schoolTermEndDimDay < currentDate)
      ) {
        return true
      }
      return false
    },
    showTermDialog() {
      if (
        !this.$store.getters.semesterSetting.showTermDialog ||
        !this.curIsAdmin
      ) {
        return false
      }
      setItem(TERM_DIALOG_OPENED, true)
      return true
    },
    computedShowCustomerService() {
      return (
        (this.isAdmin || this.isTeacher || this.isHeadmaster) &&
        !this.showTermDialog &&
        !this.listModuleShowStatus
      )
    },
    computedMenuCards() {
      let menus = []
      if (this.appList.length) {
        menus.push({
          title: '上下学管理',
          menus: this.appList,
          showTitle: !this.isZjCube
        })
      }
      if (this.appSecurityList.length) {
        menus.push({
          title: '校园安全',
          menus: this.appSecurityList,
          showTitle: true
        })
      }
      if (this.appEducationalMenus.length) {
        menus.push({
          title: this.isHeEducation ? '放学管理' : '教务教学',
          menus: this.appEducationalMenus,
          showTitle: !this.isZjCube
        })
      }
      if (this.appServeList.length && !this.isStudent) {
        menus.push({
          title: '总务后勤',
          menus: this.appServeList,
          showTitle: !this.isZjCube
        })
      }
      if (this.appEvaluationList.length && !this.isStudent) {
        menus.push({
          title: '综合评价',
          menus: this.appEvaluationList,
          showTitle: !this.isZjCube
        })
      }
      if (this.appLeaveSchoolMenus.length) {
        menus.push({
          title: '放学管理',
          menus: this.appLeaveSchoolMenus,
          showTitle: !this.isZjCube
        })
      }
      if (this.appOtherList.length && !this.isStudent) {
        menus.push({
          title: '',
          menus: this.appOtherList,
          showTitle: true,
          handler: app => this.handlerLinkOthers(app, 'pageHome')
        })
      }
      if (this.appDeviceList.length && !this.isStudent) {
        menus.push({
          title: '设备管理',
          menus: this.appDeviceList,
          showTitle: true,
          handler: app => this.handlerLinkOthers(app, 'pageHome')
        })
      }
      if (this.appBasicList.length && !this.isStudent) {
        menus.push({
          title: '基础设置',
          menus: this.appBasicList,
          showTitle: !this.isZjCube
        })
      }

      return menus
    }
  },
  /* eslint-disable */
  beforeCreate() {
    removeItem(TAB_ROLE_ID)
    this.$store.commit('expressModle', true)
  },
  created() {
    // downloadFile(this.corpId)
    // 通知的角色是没有合并的，当有些页面能返回到主页时，上方展示的角色就会有问题
    this.checkRole()

    this.$store.commit('setFaceSandBoxId', '')
    this.$store.commit('setGuardianSandBoxId', '')
    this.$store.commit('setStudentSandBoxId', '')
  },
  mounted() {
    this.setPopupOrder() // 按顺序弹窗
    window.localStorage.setItem('currentCapmusId', this.campusId)
    this.init()
    window.addEventListener('storage', this.updateSemester)
    this.getApi('getFaceSource', {}).then(res => {
      this.faceSourceType = +res
    })
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.updateSemester)
  },
  destroyed() {
    this.$store.commit('expressModle', false)
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (
        from &&
        ['/opendoor/index'].includes(
          from.path.replace(/\/(gray|full)/gi, '')
        ) &&
        +getItem('needReload') === 1
      ) {
        setItem('needReload', 0)
        window.location.hash = '#/'
      }
    })
  },
  beforeRouteLeave(to, from, next) {
    next()
  },
  methods: {
    isShowFree(app) {
      const index = this.freeModules.findIndex(item => item.moduleId === app.id)
      return {
        show: index !== -1,
        price: this.freeModules[index] ? this.freeModules[index].price : '',
        hint: this.freeModules[index] ? this.freeModules[index].hint : ''
      }
    },
    init() {
      if (this.curIsAdmin) {
        this.fetchGetFaceCount()
      }
      this.fetchModuleMessage()
      this.getFreeMenu()
    },
    // 获取限时免费套餐，需要展示提示
    getFreeMenu() {
      API.getFreeModules().then(res => {
        this.freeModules = res
      })
    },
    handlerHighlightModule(app, card) {
      if (card.handler) {
        card.handler(app)
        return
      }
      // 每次切换模块，把导航清空
      this.$store.commit('setRouteForTabbar', [])
      if (!this.verifyModuleAccess(app.module)) {
        return this.handlerAccess(app)
      }
      if (['cabinet', 'meeting'].includes(app.title)) {
        this.handlerLinkOthers(app, 'pageHome')
        return
      }
      API.clearModuleHighLight({
        moduleId: +app.id
      })

      // 如果进入的是班级评比或者德育 且学年学期开始结束时间任意为空
      const list = this.$store.getters.semesterList
      if (!this.curIsGuardian && app.termNotNull && !list.length) {
        return this.$Dialog({
          type: 'alert',
          title: '提示',
          content: this.curIsAdmin
            ? '请先设置学年学期'
            : '学期时间暂未设置，请联系管理员。',
          confirmBtn: '我知道了'
        }).show()
      }
      const _path = app.multiple ? app.path[this.currentRole] : app.path
      if (app.linkType === 2) {
        const { moduleIdList } = this.$store.getters.skuInfo
        mcOpenLink({
          url: `${_path}&currentRole=${this.currentRole}&campusId=${
            this.campusId
          }${
            // 套餐包含94 跳转到重庆防疫
            app.module === '90' && moduleIdList.some(item => +item === 94)
              ? '&modu=94'
              : ''
          }`
        })
      } else {
        // 魔方机构下菜单跳转
        if (app.routerType === 2) {
          if ((app.query || {}).deviceType) {
            this.$store.commit('setDeviceManageType', app.query.deviceType)
          }
          this.$router.push({
            path: app.path,
            query: {
              $moduleId: app.module
            }
          })
        } else {
          if (app.id === PAGE_IN_MODULE.vehiclemanage) {
            this.getApiVersion().then(v => {
              if ([2, 3].includes(v.version)) {
                this.$router.push({
                  path: _path,
                  query: {
                    $moduleId: app.module
                  }
                })
              } else {
                this.$router.push({
                  path: '/vehiclemanage/index?curPage=VehicleManageList',
                  query: {
                    ...app.query,
                    $moduleId: app.module
                  }
                })
              }
            })
          } else {
            this.$router.push({
              path: _path,
              query: app.query
            })
          }
        }
      }
    },
    entryInformation() {
      // 家长进入
      this.$router.push({
        name:
          +this.currentRole === LEAVE_ROLE.guardian
            ? 'PageEntryInformationGuardian'
            : 'PageEntryInformationIndex'
      })
    },
    handlerToInputFace() {
      if (this.curIsAdmin) {
        // devServId=56&source=devServId 钉钉给d2配置识别参数

        mcOpenLink({
          url: enterFace(this.faceSourceType, this.corpId, 3, this.appId)
        })
      } else if (this.curIsGuardian) {
        mcOpenLink({
          url: enterFace(this.faceSourceType, this.corpId, 1, this.appId)
        })
      } else {
        if (!this.classList.length) {
          return mcToast({ msg: '暂无任课班级' })
        }
        let _crumbs = this.classList.map(res => {
          return {
            name: res.name,
            id: res.tpId
          }
        })
        if (this.classList.length > 1) {
          const _that = this
          if (this.picker) {
            return this.picker.show()
          }
          this.picker = this.$Picker({
            $props: {
              columns: _crumbs,
              defaultActive: 0
            },
            $events: {
              confirm(index, value) {
                _that.gotoFaceForHeaderMatser(value)
                _that.picker && _that.picker.hide()
              }
            }
          }).show()
        } else {
          this.gotoFaceForHeaderMatser(_crumbs)
        }
      }
    },
    gotoFaceForHeaderMatser(_crumbs) {
      const { id } = _crumbs[0] || {}
      let _url = enterFace(
        this.faceSourceType,
        this.corpId,
        2,
        this.appId,
        `&isTeacher=true#/?crumbs=${encodeURI(
          JSON.stringify(_crumbs)
        )}&groupId=${id}`
      )

      mcOpenLink({
        url: _url
      })
    },
    /**
     * 查询高亮模块
     */
    fetchModuleMessage() {
      return new Promise((resolve, reject) => {
        API.listModuleHighLight()
          .then(res => {
            let _res = res || []
            this.messageIdList = _res
            resolve(_res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 查询某人公告弹窗的配置集合-套餐
    listModulePopup() {
      return new Promise((resolve, reject) => {
        API.listModulePopup({
          campusId: this.campusId,
          operUserRoleTypes: `${this.currentRole}`,
          operUserDingId: this.dingUserId,
          operUserName: this.dingUserName
        })
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 消除公告弹窗的配置
    clearModulePopup(moduleId) {
      return new Promise((resolve, reject) => {
        API.clearModulePopup({
          moduleId,
          campusId: this.campusId,
          operUserRoleTypes: `${this.currentRole}`,
          operUserDingId: this.dingUserId,
          operUserName: this.dingUserName
        })
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    async showDialog() {
      if (!this.showTermDialog) {
        try {
          await this.$store.dispatch('handlerCheckSemester')
          this.$router.push({
            path: '/schoolCalendar'
          })
        } catch (error) {
          mcToast({ msg: error.msg })
        }
      }
    },
    handlerToProtocol() {
      this.$router.push({
        path: '/protocol',
        query: {
          appId: this.protocolData[0].appId,
          developerCompanyName: this.protocolData[0].developerCompanyName,
          applyStatus: this.protocolData[0].applyStatus
        }
      })
    },
    /**
     * 获取人脸录入统计数据---协议需要 管理员用、误删
     */
    fetchGetFaceCount() {
      return new Promise((resolve, reject) => {
        let _postData = {
          moduleType: 2, // 应用类型: 1请假 2考勤
          applicantRole: `${this.currentRole}`,
          campusId: this.campusId
        }
        API.getAppOrgAuthApplyList(_postData)
          .then(res => {
            const _res = res || []
            // let { buttonName, routes, linkType } = this.menuList

            if (this.curIsAdmin && _res.length) {
              this.showProtocol = true
              this.protocolData = _res
            }
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    async updateSemester(e) {
      if (e.key === 'updateSemester' && getLocalItem('updateSemester')) {
        await this.$store.dispatch('handlerCheckSemester')
        removeLocalItem('updateSemester')
      }
    },

    // 套餐到期
    ...mapMutations('expireSku', [
      'initExpireSkuData',
      'setExpireSkuDialog',
      'initExpireSkuPrompt'
    ]),
    async initExpireSku() {
      if (!this.isAdmin || this.isZjCube) return // 非管理员或魔方
      try {
        let res = await API.getOrgExpireSku({
          userId: this.$store.getters.token.orgUserId
        })
        // 学期学年>套餐已到期>亲情通话设备已到期>套餐即将到期>亲情通话设备即将到期>信息公示>新功能上线
        // 套餐未到期，需要查询亲情通话设备是否已到期
        let expireDevice = await API.getExpireDevice({
          userId: this.$store.getters.token.orgUserId
        })
        // toBeExpirePrompt 存在两个到期、即将到期判断，正常套餐、亲情通话
        res = {
          ...res,
          deviceToBeExpirePrompt: expireDevice.toBeExpirePrompt, // 即将到期
          deviceAlreadyExpirePrompt: expireDevice.alreadyExpirePrompt, // 已经到期
          familyCallDeviceToBeExpire: expireDevice.familyCallDeviceToBeExpire,
          familyCallDeviceAlreadyExpire:
            expireDevice.familyCallDeviceAlreadyExpire
        }
        this.initExpireSkuData(res)
        this.setExpireSkuDialog()
        this.initExpireSkuPrompt()
      } catch (error) {
        console.log(error)
      }
    },
    showExpireSkuDialog() {
      this.$Dialog({
        type: 'confirm',
        title: this.promptTitle,
        content: this.promptContent,
        confirmBtn: {
          text: '联系客服',
          color: '#006AFE'
        },
        cancelBtn: {
          text: '关闭',
          color: '#333333'
        },
        $events: {
          confirm: () => {
            this.openCsLink()
          },
          cancel: () => {}
        }
      }).show()
    },
    showLeaveActiveDialog() {
      const _this = this
      this.$Dialog({
        type: 'confirm',
        title: '开学季',
        content: '完成学生进出校配置，免费领取学生请假功能',
        confirmBtn: {
          text: '前往领取',
          color: '#006AFE'
        },
        cancelBtn: {
          text: '我知道了',
          color: '#333333'
        },
        $events: {
          confirm: () => {
            _this.$router.push({
              path: '/opendoor/index',
              query: {}
            })
          },
          cancel: () => {}
        }
      }).show()
    },

    // 弹窗优先级 学期学年>套餐已到期>亲情通话设备已到期>套餐即将到期>亲情通话设备即将到期>信息公示>新功能上线>开学季送一年请假
    async setPopupOrder() {
      // 防止从模块返回首页 弹出弹窗
      if (getItem('setPopupOrder')) {
        this.listModuleShowStatus = false
        return
      }
      setItem('setPopupOrder', true)

      // 学期学年弹窗
      if (this.showTermDialog) return

      // 套餐已到期/即将到期 弹窗
      await this.initExpireSku()

      if (
        this.alreadyExpirePrompt ||
        this.toBeExpirePrompt ||
        this.deviceToBeExpirePrompt ||
        this.deviceAlreadyExpirePrompt
      ) {
        this.showExpireSkuDialog()
        return
      }

      // 请假功能升级通知 弹窗
      let { moduleIds = [] } = (await this.listModulePopup()) || {}
      const _skuModuleIds =
        (this.$store.getters.skuInfo || {}).moduleIdList || []
      // 数组存在结果时需弹框展示、存在多个值时取第一个即可
      let _moduleId = moduleIds[0]
      // if (this.isAdmin && !this.isZjCube && !_skuModuleIds.includes('2')) {
      //   this.showLeaveActiveDialog()
      //   return
      // }

      if (!_moduleId || !_skuModuleIds.includes(`${_moduleId}`)) {
        this.listModuleShowStatus = false
        return
      }
      // 亲情通话灰度发布
      if (
        this.listModuleShowStatus &&
        (getItem('graybus') || '').includes(+_moduleId)
      ) {
        let _this = this
        this.$Dialog(
          {
            type: 'confirm',
            title: '新功能上线',
            content: '学生一键呼叫班主任，紧急事件立即办',
            cancelBtn: {
              text: '关闭',
              color: '#006AFE'
            },
            classNames: 'home-module-popup',
            confirmBtn: {
              text: '前往设置',
              color: '#006AFE'
            },
            $events: {
              cancel: () => {
                _this.listModuleShowStatus = false
                _this.clearModulePopup(_moduleId)
              },
              confirm: () => {
                _this.listModuleShowStatus = false
                _this.clearModulePopup(_moduleId)
                _this.$router.push({
                  path: '/classcard/familycall/setting',
                  query: {}
                })
              }
            }
          },
          createElement => {
            return [
              createElement('div', {
                slot: 'icon',
                class: ['home-pop']
              })
            ]
          }
        ).show()
        return
      } else {
        this.listModuleShowStatus = false
      }
    },

    getApiVersion() {
      return new Promise((resolve, reject) => {
        API.getBarrierGateVersion(this.commonParams)
          .then(res => {
            this.$store.commit('setVehicleVersion', res.version)
            this.$store.commit('setParklotInfo', res)
            resolve(res)
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
    }
  }
}
</script>
<style lang="scss">
.md-popup {
  .md-dialog__content {
    text-align: justify;
  }
}
.home-pop {
  width: 100%;
  background: url('~@/assets/images/call-new.png') no-repeat top center;
  background-size: 100% 100%;
  padding-top: 57.14285%;
}
.home-module-popup {
  .md-dialog__content {
    text-align: left;
  }
}
</style>
<style lang="scss" scoped>
.common-bar {
  margin-right: 16px;
  margin-left: 16px;
  margin-bottom: 0;
  border-radius: 8px;
}
.homePage {
  overflow: scroll;
  background: #f5f5f5;
}
.message-tip {
  padding-top: 12px;
  .text-ellipsis {
    line-height: 1.2;
    padding: 3px 0px 2px 0px;
  }
}

.tips-close {
  top: 16px;
  right: 12px;
}
.swiper-container {
  width: 100%;
  height: 100%;
}
.icon-message {
  top: 16px;
  right: 32px;
  z-index: 11;
  color: #fb602d;
}
.moreTip {
  position: fixed;
  top: -6px;
  z-index: 9999;
  right: 15px;
  text-align: center;
  .triangle {
    margin-left: 140px;
    width: 0px;
    height: 0px;
    border: 6px solid #000;
    border-bottom-color: rgba(0, 0, 0, 0.72);
    border-top-color: transparent;
    border-left-color: transparent;
    border-right-color: transparent;
  }
  .moreTipContent {
    border-radius: 3px;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.72);
    color: #ffffff;
    width: 148px;
    padding: 10px 10px 6px 10px;
    line-height: 21px;
    text-align: center;
    background: rgba(0, 0, 0, 0.72);
    color: #ffffff;
    box-sizing: content-box;
  }
}
.top-12 {
  top: 12px;
}
.cs-tip {
  right: 16px;
  bottom: -28px;
  z-index: 2099;
  &.is-top {
    :deep(.md-tip__indicator) {
      left: 100%;
      transform: translateX(-36px);
      margin-top: -5px;
    }
    :v-deep(.md-tip__content) {
      height: 20px;
      line-height: 20px;
    }
  }
}
:deep(.md-swiper .md-swiper__indicators--icon) {
  color: rgba(255, 255, 255, 0.4);
}
:deep(.md-swiper .md-swiper__indicators--icon.is-active) {
  color: rgba(255, 255, 255, 1);
}
:deep(.md-swiper .md-swiper__indicators) {
  bottom: 5px;
}
.free-num {
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
}
</style>
